import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

// Attach token to every request
API.interceptors.request.use(config => {
  const token = localStorage.getItem('bp_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Redirect to login on 401
API.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && window.location.pathname !== '/login') {
      localStorage.removeItem('bp_token');
      localStorage.removeItem('bp_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (data) => API.post('/auth/login', data),
  logout: () => API.post('/auth/logout'),
};

export const settingsAPI = {
  get: () => API.get('/settings'),
  update: (data) => API.put('/settings', data, { headers: { 'Content-Type': 'multipart/form-data' } }),
};

export const billsAPI = {
  getAll: (params) => API.get('/bills', { params }),
  getOne: (id) => API.get(`/bills/${id}`),
  create: (data) => API.post('/bills', data),
  update: (id, data) => API.put(`/bills/${id}`, data),
  delete: (id) => API.delete(`/bills/${id}`),
};

export const receiptsAPI = {
  getAll: (params) => API.get('/receipts', { params }),
  getOne: (id) => API.get(`/receipts/${id}`),
  create: (data) => API.post('/receipts', data),
  delete: (id) => API.delete(`/receipts/${id}`),
};

export const clientsAPI = {
  getAll: (params) => API.get('/clients', { params }),
  create: (data) => API.post('/clients', data),
  update: (id, data) => API.put(`/clients/${id}`, data),
  delete: (id) => API.delete(`/clients/${id}`),
};

export default API;